import { cn } from "../cn";

export interface InitialTileProps {
  name: string;
  size?: "sm" | "md";
  className?: string;
}

const SIZE: Record<NonNullable<InitialTileProps["size"]>, string> = {
  sm: "size-6 text-micro",
  md: "size-8 text-ui",
};

/** A studio's or a service's first letter, on a sunk square, where there is no logo. */
export function InitialTile({ name, size = "md", className }: InitialTileProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "grid shrink-0 place-items-center rounded-[var(--radius-sm)] bg-sunk font-mono font-semibold text-ink-2",
        SIZE[size],
        className,
      )}
    >
      {name.charAt(0).toUpperCase()}
    </span>
  );
}
